import { get, sortBy } from "lodash";
import { createSelector } from "reselect";
import { getPageContent } from "../../shared/selectors";

const getProjectQuestionGroups = createSelector(
  [getPageContent],
  pageContent => {
    return sortBy(get(pageContent, "project_question_groups", []), [
      "position"
    ]);
  }
);

export default getProjectQuestionGroups;
